import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays SVG Icon
 *
 * @param {Object} props
 * @param {string} props.icon
 * @param {string} props.stroke
 */
const Icon = ( { icon, stroke } ) => {
	if ( 'plus' === icon ) {
		return (
			<svg
				width="256"
				height="256"
				viewBox="0 0 256 256"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M185.066 128c0 3.534-2.866 6-6.4 6H134v44.666c0 3.534-2.467 6.399-6 6.399-3.534 0-6-2.865-6-6.399V134H77.332c-3.535 0-6.4-2.466-6.4-6s2.866-6 6.4-6H122V77.331c0-3.534 2.466-6.4 6-6.4 3.533 0 6 2.866 6 6.4V122h44.666c3.534 0 6.4 2.466 6.4 6zM256 128C256 57.42 198.58 0 128 0S0 57.42 0 128s57.42 128 128 128 128-57.42 128-128zm-12.8 0c0 63.521-51.679 115.2-115.2 115.2-63.522 0-115.2-51.679-115.2-115.2C12.8 64.478 64.478 12.8 128 12.8c63.521 0 115.2 51.678 115.2 115.2z"
					fillRule="nonzero"
				/>
			</svg>
		);
	} else if ( 'drag' === icon ) {
		return (
			<svg
				width="10"
				height="6"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="4 6 10 6"
				role="img"
				aria-hidden="true"
				focusable="false"
			>
				<path d="M13,8c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S12.4,8,13,8z M5,6C4.4,6,4,6.4,4,7s0.4,1,1,1s1-0.4,1-1S5.6,6,5,6z M5,10 c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S5.6,10,5,10z M13,10c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S13.6,10,13,10z M9,6 C8.4,6,8,6.4,8,7s0.4,1,1,1s1-0.4,1-1S9.6,6,9,6z M9,10c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S9.6,10,9,10z"></path>
			</svg>
		);
	} else if ( 'chevron-up' === icon ) {
		return (
			<svg
				width="12"
				height="7"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="3.3 4.5 11.4 7"
				role="img"
				aria-hidden="true"
				focusable="false"
			>
				<polygon points="9,4.5 3.3,10.1 4.8,11.5 9,7.3 13.2,11.5 14.7,10.1 "></polygon>
			</svg>
		);
	} else if ( 'chevron-down' === icon ) {
		return (
			<svg
				width="12"
				height="7"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="3.3 6.5 11.4 7"
				role="img"
				aria-hidden="true"
				focusable="false"
			>
				<polygon points="9,13.5 14.7,7.9 13.2,6.5 9,10.7 4.8,6.5 3.3,7.9 "></polygon>
			</svg>
		);
	} else if ( 'chevron-right' === icon ) {
		return (
			<svg
				focusable="false"
				xmlns="http://www.w3.org/2000/svg"
				width="7"
				height="11.4"
				viewBox="5.8 2.3 7 11.4"
			>
				<polygon points="12.8,8 7.2,2.3 5.8,3.8 10,8 5.8,12.2 7.2,13.7 " />
			</svg>
		);
	} else if ( 'pencil' === icon ) {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 20 20"
				width="16"
				height="16"
				className="edit-svg"
			>
				<rect x="0" fill="none" width="20" height="20" />
				<g>
					<path d="M13.89 3.39l2.71 2.72c.46.46.42 1.24.03 1.64l-8.01 8.02-5.56 1.16 1.16-5.58s7.6-7.63 7.99-8.03c.39-.39 1.22-.39 1.68.07zm-2.73 2.79l-5.59 5.61 1.11 1.11 5.54-5.65zm-2.97 8.23l5.58-5.6-1.07-1.08-5.59 5.6z" />
				</g>
			</svg>
		);
	} else if ( 'undo' === icon ) {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
			>
				<path d="M0 0h24v24H0z" fill="none" />
				<path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
			</svg>
		);
	} else if ( 'dropdown' === icon ) {
		return (
			<svg
				width="11"
				height="8"
				viewBox="0 0 14 8"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M1 1l6 6 6-6"
					stroke={ stroke ? stroke : '#006799' }
					strokeWidth="2"
					fill="none"
					fillRule="evenodd"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		);
	} else if ( 'warning' === icon ) {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				x="0"
				y="0"
				width="554.2"
				height="554.199"
				viewBox="0 0 554.2 554.199"
			>
				<title>The question is empty.</title>
				<path
					d="M538.5,386.199L356.5,70.8c-16.4-28.4-46.7-45.9-79.501-45.9c-32.8,0-63.1,17.5-79.5,45.9L12.3,391.6
					c-16.4,28.4-16.4,63.4,0,91.8C28.7,511.8,59,529.3,91.8,529.3H462.2c0.101,0,0.2,0,0.2,0c50.7,0,91.8-41.101,91.8-91.8
					C554.2,418.5,548.4,400.8,538.5,386.199z M316.3,416.899c0,21.7-16.7,38.3-39.2,38.3s-39.2-16.6-39.2-38.3V416
					c0-21.601,16.7-38.301,39.2-38.301S316.3,394.3,316.3,416V416.899z M317.2,158.7L297.8,328.1c-1.3,12.2-9.4,19.8-20.7,19.8
					s-19.4-7.7-20.7-19.8L237,158.6c-1.3-13.1,5.801-23,18-23H299.1C311.3,135.7,318.5,145.6,317.2,158.7z"
				></path>
			</svg>
		);
	}
	return null;
};

/**
 * Valid props
 */
Icon.propTypes = {
	icon: PropTypes.string,
	stroke: PropTypes.string,
};

export default Icon;
